import {useMemo} from "react";

import {v4 as uuidv4} from "uuid";

export default function useInputId(name = ""): string {
  const uniqueId = useMemo(() => uuidv4(), []);

  return `input-${name}-${uniqueId}`;
}
